import { render, staticRenderFns } from "./MessageCardItem.vue?vue&type=template&id=fb11ec52&scoped=true"
import script from "./MessageCardItem.vue?vue&type=script&lang=ts"
export * from "./MessageCardItem.vue?vue&type=script&lang=ts"
import style0 from "./MessageCardItem.vue?vue&type=style&index=0&id=fb11ec52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb11ec52",
  null
  
)

export default component.exports